<h1 style="text-align: center;">OBJETIVOS SGI</h1>
<mdb-lightbox class="lightbox">
    <div class="row">
      <div class="col-lg-4">
        <img
          mdbLightboxItem
          src="assets/images/sliders-objetivos-sgi/thumb_slider1.png"
          [img]="'assets/images/sliders-objetivos-sgi/slider1.png'"
          alt="Lightbox image 1"
          class="w-100"
        />
      </div>
      <div class="col-lg-4">
        <img
          mdbLightboxItem
          src="assets/images/sliders-objetivos-sgi/thumb_slider2.png"
          [img]="'assets/images/sliders-objetivos-sgi/slider2.png'"
          alt="Lightbox image 2"
          class="w-100"
        />
      </div>
      <div class="col-lg-4">
        <img
          mdbLightboxItem
          src="assets/images/sliders-objetivos-sgi/thumb_slider3.png"
          [img]="'assets/images/sliders-objetivos-sgi/slider3.png'"
          alt="Lightbox image 3"
          class="w-100"
        />
      </div>
    </div>
  </mdb-lightbox>